import { List } from '@gonfalon/immutable-shim/immutableShim';

import { AccessDecision } from './records/AccessDecision';

export function combineAccessDecisions(...args: Array<AccessDecision | undefined | null>) {
  const decisions = List(args.filter((d) => !!d));
  const isAllowed = decisions.every((d) => d.isAllowed);
  const firstDenied = decisions.find((d) => !d.isAllowed);
  return new AccessDecision({
    isAllowed,
    reason: firstDenied ? firstDenied.reason : decisions.first<AccessDecision>().reason,
    appliedRoleName: firstDenied ? firstDenied.appliedRoleName : decisions.first<AccessDecision>().appliedRoleName,
    customMessage: firstDenied?.customMessage,
  });
}
